import React, { useCallback, useState, forwardRef } from "react";
import useClx from "../../../hooks/use-clx";
import clxs from "./cluster-house-rules.module.css";
import READ_MORE from "../../../assets/read-more-chevron.svg";
import READ_LESS from "../../../assets/read-less-chevron.svg";
import PerVillaRules from "./PerVillaRules";
import useIsMobile from "../../../hooks/use-is-mobile";

interface ClusterHouseRulesProps {
  title: string;
  houseRules:HouseRule[];
  className?: string;
  isSticky?: boolean;
}

const ClusterHouseRules = forwardRef<HTMLUListElement, ClusterHouseRulesProps>(
  function HouseRuleCore(props, ref) {
    const [collapsed, setCollapsed] = useState<boolean>(false),
      {
        className,
        title,
        houseRules,
        isSticky,
      } = props;

    const ccx = useClx(clxs.container, className),
      tcx = useClx(
        isSticky ? clxs.stickyContainer : clxs.titleContainer,
        "title",
      ),
      { isMobile } = useIsMobile(),
      handleToggle = useCallback(() => {
        setCollapsed((collapsed) => !collapsed);
      }, [setCollapsed]);

      const formatRules = (rules: string[]): string => {
        return rules
          .map(rule => {
            const lines = rule.split("\r\n");
            return [`• ${lines[0].trim()}`, ...lines.slice(1).map(line => `   ${line.trim()}`)].join("\r\n");
          })
          .join("\r\n");
      };

      const showDesktopRules = houseRules && !isMobile;
      const showMobileRules = houseRules && isMobile && collapsed;


    return (
      <ul
        className={ccx}
        ref={ref}
      >
        <div
          className={tcx}
          onClick={handleToggle}
        >
          {title}
          <img
            className={clxs.readMoreIcon}
            src={collapsed ? READ_LESS : READ_MORE}
            alt="read-more"
          />
        </div>

        {showDesktopRules ?
          (houseRules.map((each, index) => (
            <PerVillaRules
              key={index}
              propertyName={each.property_name}
              description={formatRules(each.rules)}
              className={clxs.desktopPerVillaRules}
            />
          ))) : null}

        <div className={clxs.mobileRules}>
        {showMobileRules ? (
            houseRules.map((each, index) => (
              <PerVillaRules
                key={index}
                propertyName={each.property_name}
                description={formatRules(each.rules)}
                className={clxs.mobilePerVillaRules}
              />
            ))): null}
        </div>
      </ul>
    );
  },
);

export default ClusterHouseRules;

